import React from "react";

function HelpIcon(props) {
  return (
    <div className="HelpIcon">
      <p className="HelpIconPanel">{props.text}</p>
      <i class="fas fa-question-circle" />
    </div>
  );
}

export default HelpIcon;



// WEBPACK FOOTER //
// ./src/components/HelpIcon.js